import { useContext } from "react";
import {
  VerOrdenDigitalLaboratorioBody,
  VerOrdenDigitalLaboratorioBotones,
  VerOrdenDigitalLaboratorioContainer,
  VerOrdenDigitalLaboratorioHeader,
} from "./localStyle";
import { PortalContext } from "_+_Portal/context/Provider";
import { hideModal } from "_+_Portal/context/Actions/modal/modal";
import { resetPDFOrdenDigital } from "_+_Portal/context/Actions/pdfOrdenDigital/pdfOrdenDigital";
import { resetPDFOrdenEstudio } from "_+_Portal/context/Actions/ordenDigital/ordenDigital";

const VerOrdenDigitalLaboratorio = ({ base64 }) => {
  //#region --------- context ---------------
  // const { modalDispatch } = useContext(GlobalContext);
  const {
    modalDispatch,
    pdfOrdenDigitalDispatch,
    ordenDigitalDispatch,
  } = useContext(PortalContext);
  //#endregion  ----------- context ---------------

  //#region  ----------- constants ---------------
  const blob = base64ToBlob(base64, "application/pdf");
  const url = URL.createObjectURL(blob);

  //#endregion --------- constants ---------------

  //#region  ----------- funciones ---------------
  const cerrarModal = () => {
    hideModal()(modalDispatch);
    resetPDFOrdenDigital()(pdfOrdenDigitalDispatch);
    resetPDFOrdenEstudio()(ordenDigitalDispatch);
  };

  function base64ToBlob(base64, type = "application/octet-stream") {
    const binStr = atob(base64);
    const len = binStr.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      arr[i] = binStr.charCodeAt(i);
    }
    return new Blob([arr], { type: type, title: "Informe" });
  }
  //#endregion --------- funciones ---------------

  //#region  ----------- useEffect ---------------
  //#endregion  ----------- useEffect ---------------
  return (
    <VerOrdenDigitalLaboratorioContainer>
      <VerOrdenDigitalLaboratorioHeader>
        <span className="c-white rb16b">Orden Digital</span>
        <div className="cruz-ordenDigital" onClick={cerrarModal}>
          <div className="cruzParte1-ordenDigital"></div>
          <div className="cruzParte2-ordenDigital"></div>
        </div>
      </VerOrdenDigitalLaboratorioHeader>
      <VerOrdenDigitalLaboratorioBody>
        <iframe
          title="informe"
          className="ptur-pdfOrdenDigital"
          src={url}
          type="application/octet-stream"
        />
      </VerOrdenDigitalLaboratorioBody>
    </VerOrdenDigitalLaboratorioContainer>
  );
};

export default VerOrdenDigitalLaboratorio;
